import $ from 'jquery';

$.noConflict();
$( document ).ready( function ( w ) {
	// Fancybox initialisation
	if ( $.fn.fancybox ) {
		w( "a[data-fancybox='gallery']" ).fancybox( {} );
	}
} );
